// extracted by mini-css-extract-plugin
export default {"container":"BUSINESS_STORY_container__7uyo0","card":"BUSINESS_STORY_card__0Gfei"};